import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  coverPhotos: {},
  coverList: [],
  rooms: {},
  gallery: [],
  featuredMedia: [],
  videos: [],
  loading: false,
  error: null,
  lastFetched: null,
};

const mediaSlice = createSlice({
  name: "media",
  initialState,
  reducers: {
    setMediaLoading: (state, action) => {
      state.loading = action.payload !== false;
    },
    setMediaData: (state, action) => {
      const payload = action.payload || {};
      state.data = payload;
      state.coverPhotos = payload.coverPhotos || {};
      state.coverList = payload.coverList || [];
      state.rooms = payload.rooms || {};
      state.gallery = payload.images || payload.allMedia || [];
      state.featuredMedia = payload.featuredMedia || [];
      state.videos = payload.videos || [];
      state.loading = false;
      state.error = null;
      state.lastFetched = Date.now();
    },
    setMediaError: (state, action) => {
      state.loading = false;
      state.error = action.payload || "Failed to load media";
    },
    clearMedia: (state) => {
      state.data = null;
      state.coverPhotos = {};
      state.rooms = {};
      state.gallery = [];
      state.videos = [];
      state.loading = false;
      state.error = null;
      state.lastFetched = null;
    },
  },
});

export const { setMediaLoading, setMediaData, setMediaError, clearMedia } =
  mediaSlice.actions;
export default mediaSlice.reducer;
